import type { ContaminantIO } from '@/api';

export default class Contaminant implements ContaminantIO {
    description = '';
    AHPreferredCode = '';
    AEPContaminationGroupCode = '';
    isGroundWaterImpacted = '';
    isSurfaceWaterImpacted = '';
    isOnSiteSoilImpacted = '';
    isOffSiteSoilImpacted = '';

    constructor(data: ContaminantIO) {
        Object.assign(this, data);
    }
}
